import { callOperation } from '../operations'
import * as resources from '../operations/resources'

const deleteList = async (args) => {
  const actionResult = await callOperation('operations/delete-list', args)
  resources.invalidateQueriesUsing(entitiesUsed)
  return actionResult
}

export const entitiesUsed = ['List', 'Card']

export default deleteList


